import { type ProfileStat } from './components/StatBar';

export const stats: ProfileStat[] = [
  { label: 'Problem Solving', value: 9 },
  { label: 'Cloud Engineering', value: 8 },
  { label: 'Frontend Development', value: 7 },
  { label: 'Backend Development', value: 9 },
];
